/**
 * TaxEmailHistory (TAX-EMAIL-UI-SIMPLIFY-001) — superseded / older Tax Collector email attempts, collapsed by
 * default and strictly read-only (no Received / Resend). Audit data stays intact; this only changes presentation.
 */
import React, { useState } from 'react';
import { ChevronDown, ChevronRight, History } from 'lucide-react';
import { STATUS, fmt } from './TaxEmailRequestCard';

export default function TaxEmailHistory({ history }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="pt-1" data-testid="tax-email-history">
      <button onClick={() => setOpen((v) => !v)} data-testid="tax-email-history-toggle"
        className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-700">
        {open ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
        <History className="w-3.5 h-3.5" /> View Email History ({history.length})
      </button>
      {open && (
        <ul className="mt-2 divide-y divide-slate-100 border border-slate-200 rounded-md bg-slate-50/60" data-testid="tax-email-history-list">
          {history.map((rec) => {
            const s = STATUS[rec.status] || STATUS.not_configured;
            return (
              <li key={rec.id} className="px-3 py-1.5 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-[11px] text-slate-500" data-testid={`tax-email-history-${rec.id}`}>
                <span className="font-medium text-slate-700">{rec.jurisdiction_name}</span>
                <span className={`inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-medium ${s.cls}`}>{s.label}</span>
                <span className="font-mono">{rec.recipient || '—'}</span>
                <span>{rec.sent_at ? `Sent ${fmt(rec.sent_at)}` : `Recorded ${fmt(rec.created_at)}`}</span>
                <span>by {rec.sent_by_name || '—'}</span>
                {rec.received_at && <span className="text-teal-600">Received {fmt(rec.received_at)}</span>}
                {rec.error && <span className="text-rose-500 truncate max-w-full" title={rec.error}>{rec.error}</span>}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
